"use strict";
class Invariantor {
    constructor(outgoingMessageToEnsure) {
        this.outgoingMessageToEnsure = outgoingMessageToEnsure;
    }
    value() {
        return this.outgoingMessageToEnsure;
    }
}
module.exports = entity => new Invariantor(entity).value();
